import React, { useEffect, useState } from 'react'
import { Divider } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Icon, Flex } from '@ui'
import css from './toggleBookDeskButton.module.scss'
import cx from 'classnames'
import deskIcon from '../../assets/book_desk_icon.svg'
import { IAssignmentPlan } from '@api/types'
import { DateUtil, getStartAndEndDate } from '@utils'
import { useFloor } from '@providers/mapProvider'
import useSettings from 'components/NewSettings/hooks/useSettings'
import { useAppData, useBookingDesk } from '@providers'

export default function ToggleBookDeskButton({
  toggleBookDesk,
  assignmentPlan,
}: {
  toggleBookDesk: (action: number) => void
  assignmentPlan: IAssignmentPlan
}) {
  enum Toggle {
    DESK,
    MEETING_ROOM,
  }
  const tooltipContent = 'Bookings allowed only on Primary Plan'
  const floor = useFloor()
  const [bookMeetingRoom, setBookMeetingRoom] = useState(floor?.isBookMeetingRoomPage)
  const [bookDesk, setBookDesk] = useState(floor?.isBookDeskPage)
  const booking = useBookingDesk()
  const {
    product: { features },
  } = useAppData()
  const timezone = floor.map?.building.timezone || ''
  const { hourlyBookingEnabled, dailyBookingEnabled } = useSettings()

  const meetingRoomEnabled = features.includes('meetingRoomBooking')
  const toggleDeskAndMeeting = (action: number) => {
    if (action === Toggle.DESK) {
      setBookDesk(!bookDesk)
      setBookMeetingRoom(false)
    }
    if (action === Toggle.MEETING_ROOM) {
      setBookMeetingRoom(!bookMeetingRoom)
      setBookDesk(false)
    }
    const { fromDate, toDate } = getStartAndEndDate({
      timezone,
      allDay: !hourlyBookingEnabled && dailyBookingEnabled,
      defaultTimeFrom: floor.bookingWorkdayTimeFrom,
      defaultTimeTo: floor.bookingWorkdayTimeTo,
      startDate: DateUtil.tz(timezone),
    })
    booking.updateBookingDate({ fromDate, toDate })
    toggleBookDesk(action)
  }

  useEffect(() => {
    setBookDesk(floor?.isBookDeskPage)
    setBookMeetingRoom(floor?.isBookMeetingRoomPage)
  }, [floor?.isBookDeskPage, floor?.isBookMeetingRoomPage])

  return (
    <Flex align="center" justify="space-between">
      <Tooltip2
        placement="bottom"
        content={assignmentPlan?.name === 'Current' ? 'Book Desk' : tooltipContent}>
        <button
          className={cx(
            css.paddingSpacing,
            bookDesk ? css.buttonActiveClass : css.buttonInactiveClass
          )}
          data-test="book-desk-test"
          onClick={assignmentPlan?.name === 'Current' ? () => toggleDeskAndMeeting(0) : () => {}}>
          <img className={css.deskImageClass} src={deskIcon} />
        </button>
      </Tooltip2>
      {meetingRoomEnabled && <Divider />}
      {meetingRoomEnabled && (
        <Tooltip2
          placement="bottom"
          content={assignmentPlan?.name === 'Current' ? 'Book Meeting Room' : tooltipContent}>
          <button
            className={cx(
              css.paddingSpacing,
              bookMeetingRoom ? css.buttonActiveClass : css.buttonInactiveClass
            )}
            data-test="book-meeting-room-test"
            onClick={assignmentPlan?.name === 'Current' ? () => toggleDeskAndMeeting(1) : () => {}}>
            <Icon name="screen-users" />
          </button>
        </Tooltip2>
      )}
    </Flex>
  )
}
